import React from "react";
import OnboardingScreen, { OnboardingErrorText, OnboardingTitle } from "../OnboardingScreen";
import { OnboardingNextButton } from "../OnboardingButtons";
import PeakTextField from "../PeakTextField";
import { OnboardingLegalCheckbox } from "./CreateAccountStep";

interface EmailStepProps {
  email: string;
  password: string;
  authBusy: boolean;
  authError: string | null;
  canContinue: boolean;
  legalAccepted: boolean;
  onLegalAcceptedChange: (accepted: boolean) => void;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onBack: () => void;
  onCreateAccount: () => void;
}

const EmailStep: React.FC<EmailStepProps> = ({
  email,
  password,
  authBusy,
  authError,
  canContinue,
  legalAccepted,
  onLegalAcceptedChange,
  onEmailChange,
  onPasswordChange,
  onBack,
  onCreateAccount,
}) => (
  <OnboardingScreen
    onBack={onBack}
    footer={
      <OnboardingNextButton
        label={authBusy ? "Creating account…" : "Create account"}
        enabled={canContinue && legalAccepted}
        onClick={onCreateAccount}
      />
    }
  >
    <form
      className="flex flex-col gap-7"
      onSubmit={(e) => {
        e.preventDefault();
        if (canContinue && legalAccepted) onCreateAccount();
      }}
    >
      <OnboardingTitle title="Continue with email" />
      <div className="flex flex-col gap-3">
        <PeakTextField
          label="Email Address"
          name="email"
          value={email}
          onChange={onEmailChange}
          placeholder="you@email.com"
          type="email"
          autoComplete="email"
          autoCapitalize="none"
          inputMode="email"
          error={Boolean(authError)}
        />
        <PeakTextField
          label="Password"
          name="new-password"
          value={password}
          onChange={onPasswordChange}
          placeholder="Password"
          type="password"
          autoComplete="new-password"
          error={Boolean(authError)}
          onSubmit={() => canContinue && legalAccepted && onCreateAccount()}
        />
        <OnboardingLegalCheckbox accepted={legalAccepted} onChange={onLegalAcceptedChange} />
      </div>
      <OnboardingErrorText>{authError}</OnboardingErrorText>
    </form>
  </OnboardingScreen>
);

export default EmailStep;
